import React from 'react';
import { getText } from '../helpers/translationHelper';

function LocaleText({ textKey, args }) {
    return getText(textKey, args);
}

export default LocaleText;
